"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/TFFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_223)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_223`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H27.6V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#0A388A"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H12.08V12H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.35999 0H11.12V11.2H5.35999V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.23999 0H5.52001V11.2H-0.23999V0ZM17.2 9.6H25.2L24.4 11.2H22V12H23.6L22.8 13.6H22V16H20.4V11.2H18L17.2 9.6ZM23.6 13.6L25.2 16H22L23.6 13.6ZM18.8 13.6L20.4 16H17.2L18.8 13.6ZM21.2 18.4L19.6 16H22.8L21.2 18.4ZM26 12.8C25.52 12.8 25.2 12.48 25.2 12C25.2 11.52 25.52 11.2 26 11.2C26.48 11.2 26.8 11.52 26.8 12C26.8 12.48 26.48 12.8 26 12.8ZM16.4 12.8C15.92 12.8 15.6 12.48 15.6 12C15.6 11.52 15.92 11.2 16.4 11.2C16.88 11.2 17.2 11.52 17.2 12C17.2 12.48 16.88 12.8 16.4 12.8ZM18 19.2C17.52 19.2 17.2 18.88 17.2 18.4C17.2 17.92 17.52 17.6 18 17.6C18.48 17.6 18.8 17.92 18.8 18.4C18.8 18.88 18.48 19.2 18 19.2ZM24.4 19.2C23.92 19.2 23.6 18.88 23.6 18.4C23.6 17.92 23.92 17.6 24.4 17.6C24.88 17.6 25.2 17.92 25.2 18.4C25.2 18.88 24.88 19.2 24.4 19.2ZM21.2 20.8C20.72 20.8 20.4 20.48 20.4 20C20.4 19.52 20.72 19.2 21.2 19.2C21.68 19.2 22 19.52 22 20C22 20.48 21.68 20.8 21.2 20.8Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_223`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as TFFlag };
